/*
 *
 * UserAction reducer
 *
 */

import ActionTypes from './constants';
import { ContainerState, ContainerActions } from './types';

export const initialState: ContainerState = {
  submitting: false,
  saveMode: undefined,
};

function userActionsReducer(
  state: ContainerState = initialState,
  action: ContainerActions,
): ContainerState {
  switch (action.type) {
    case ActionTypes.SAVE_FURNITURE_REQUEST:
      return { ...state, submitting: true, saveMode: action.payload.saveMode };
    case ActionTypes.SAVE_FURNITURE_SUCCESS:
      return { ...state, submitting: false, saveMode: action.payload.saveMode };
    case ActionTypes.SAVE_FURNITURE_FAILURE:
      return { ...state, submitting: false, saveMode: action.payload.saveMode };
    case ActionTypes.RESET_SAVEMODE:
      return { ...state, saveMode: undefined };
    default:
      return state;
  }
}

export default userActionsReducer;
